import { numberToFormatted, validateTextWithHypen, } from '@/utils';
import { i18n } from '@/locales';
export default class ShareInfo {
    /** 수주허브리스트 (공유) */
    _shares;
    /** 수주허브리스트 (미공유) */
    _unShares;
    /** 수주허브리스트 (타총판 공유) */
    _sharesOfOthers;
    constructor({ shares, unShares, sharesOfOthers }) {
        this._shares = shares;
        this._unShares = unShares;
        this._sharesOfOthers = sharesOfOthers;
    }
    // eslint-disable-next-line class-methods-use-this
    formattedSharesList(list, shareConfigButtonInfo) {
        return list.filter(({ hubStatus }) => hubStatus !== 'DELETE').reduce((acc, info, idx) => {
            if (!acc[idx]) {
                acc[idx] = {};
            }
            // eslint-disable-next-line no-restricted-syntax
            for (const [key, value,] of Object.entries(info)) {
                switch (key) {
                    case 'hubStatus':
                        acc[idx][key] = value;
                        break;
                    case 'isDisplayedOnOrder':
                        if (typeof value === 'boolean') {
                            acc[idx][key] = value ? i18n.t('common.use')
                                : i18n.t('common.no_use');
                        }
                        else {
                            // TODO 주영님 여기 나중에 봐주세요 20240216 tg0825
                            // @ts-ignore
                            acc[idx][key] = validateTextWithHypen(value);
                        }
                        break;
                    case 'shareDelaySecond':
                        acc[idx][key] = value === 0 || value ? i18n.t('unit.second_suffix', {
                            second: numberToFormatted(value),
                        }) : validateTextWithHypen(value);
                        break;
                    case 'feeRate':
                    case 'storeFeeRate':
                    case 'storeManagementFeeRate':
                    case 'workerFeeRate':
                        acc[idx][key] = value === 0 || value ? `${value} : ${100 - value}` : validateTextWithHypen(value);
                        break;
                    default:
                        acc[idx][key] = validateTextWithHypen(value);
                }
                acc[idx].shareConfigButtonInfo = shareConfigButtonInfo;
            }
            return acc;
        }, []);
    }
    get formattedShares() {
        const shareConfigButtonInfo = {
            isConfigBefore: true,
            isConfigAvailable: true,
        };
        return this.formattedSharesList(this._shares, shareConfigButtonInfo);
    }
    get formattedUnShares() {
        const shareConfigButtonInfo = {
            isConfigBefore: false,
            isConfigAvailable: true,
        };
        return this.formattedSharesList(this._unShares, shareConfigButtonInfo);
    }
    get formattedSharesOfOthers() {
        const shareConfigButtonInfo = {
            isConfigBefore: true,
            isConfigAvailable: false,
        };
        return this.formattedSharesList(this._sharesOfOthers, shareConfigButtonInfo);
    }
}
